import React from "react";
import CareersSubNav from "../components/careersSubNav";

const faqs = [
  {
    q: "How do I apply?",
    a: "Email your profile to info@nirkana.com with the role name in the subject, or message us on WhatsApp from the role's page. There's no separate application portal.",
  },
  {
    q: "Is this role paid?",
    a: "Yes. Compensation for the current opening is performance-based rather than a fixed salary, and is discussed directly during the interview.",
  },
  {
    q: "Is the role remote?",
    a: "The current opening is fully remote. Some future roles may be based in or around Chennai — this will be noted on the specific job listing.",
  },
  {
    q: "How long does the process take?",
    a: "Given how small we are, most candidates hear back within a few days of applying, and the full process is usually just a couple of conversations.",
  },
  {
    q: "I don't have much experience — should I still apply?",
    a: "If you can make a real case for what you'd bring, yes. We've kept experience requirements low deliberately for early roles.",
  },
  {
    q: "Can I apply for a role that isn't open yet?",
    a: "Yes — email info@nirkana.com with the role you're interested in and we'll reach out when it opens.",
  },
];

const Faq = () => {
  return (
    <div>
      <section className="bg-cloud py-14 lg:py-20">
        <div className="max-w-content mx-auto px-6 lg:px-10">
          <h1 className="text-3xl font-bold text-brand sm:text-4xl">Frequently asked questions</h1>
        </div>
      </section>

      <CareersSubNav />

      <section className="bg-paper py-16 lg:py-24">
        <div className="max-w-content mx-auto px-6 lg:px-10">
          <div className="max-w-prose space-y-8">
            {faqs.map((item) => (
              <div key={item.q} className="border-t border-line pt-6">
                <h3 className="font-semibold text-charcoal">{item.q}</h3>
                <p className="mt-2 text-sm text-muted">{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Faq;
